import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/common/useAuth'
import { useSpaceRedirect } from '@/hooks/features/space/useSpaceRedirect'
import { LoadingSpinner } from '@/components/common/ui/loading-spinner'

export function PublicOnlyRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()
  const { initialSpace, isLoading } = useSpaceRedirect()

  if (isLoading) {
    return <LoadingSpinner />
  }

  if (user) {
    return <Navigate to={initialSpace ? `/space/${initialSpace}` : '/'} replace />
  }

  return <>{children}</>
}
